import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from 'use-analytics';

export const RouteTracker = () => {
  const { page } = useAnalytics();
  const location = useLocation();

  // track page view
  useEffect(() => {
    page();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return null;
};
